module.exports = __webpack_public_path__ + "Roboto-Regular.2751ee43015f9884c364.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Regular.woff2
// module id = ../../../../../font/roboto/Roboto-Regular.woff2
// module chunks = styles